import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { StaticData } from '../../config/enum/staticData';
import { fetchDashboardEarnings, fetchDashboardMetrics, fetchStaticData } from '../../services/dashboard-service';
import { setSession } from '../../store/reducers/appSlice';
import { setEarningsData, setIsMetricsAPICalled, setMetricsData } from '../../store/reducers/heaterSlice';
import { updateStaticStateData } from '../../store/reducers/staticDataSlice';
import { updateLoginStatus } from '../../store/reducers/userSlice';
import { INavigationConfig, NavigationConfig } from '../../utils/navigation-constants';

const navConfig: INavigationConfig = NavigationConfig;

export const useHandleLoginOnSuccess = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const fetchData = async () => {
        dispatch(setIsMetricsAPICalled(false));
        const earnings = await fetchDashboardEarnings();
        const metrics = await fetchDashboardMetrics(true);
        const staticData = await fetchStaticData();
        if (earnings) {
            dispatch(
                setEarningsData({
                    gpu_earning_month: earnings?.gpu_earning_month,
                    storage_earning_month: earnings?.storage_earning_month,
                    gpu_earning_total: earnings?.gpu_earning_total,
                    storage_earning_total: earnings?.storage_earning_total,
                    machine_name: earnings?.machine_name,
                    gpu_earnings_updated_at: earnings?.gpu_earnings_updated_at,
                }),
            );
        }
        if (metrics) {
            dispatch(setIsMetricsAPICalled(true));
            dispatch(
                setMetricsData({
                    power_sensor_timestamp: metrics?.sensor_timestamp,
                    water_sensor_timestamp: metrics?.sensor_timestamp,
                    avg_gpu_util_7d: metrics?.avg_gpu_util_7d,
                    avg_gpu_util_30d: metrics?.avg_gpu_util_30d,
                    power_usage: metrics?.power_usage,
                    water_temperature: metrics?.water_temperature,
                    temperature_history: metrics?.temperature_history,
                    power: metrics?.power,
                    internet: metrics?.internet,
                    machine_id: metrics?.device_id,
                    heatingStatus: metrics?.heating_status,
                    computingStatus: metrics?.computing_status,
                }),
            );
        }
        if (staticData) {
            const tempStaticData = staticData?.[StaticData.TEMPERATURE];
            const privacyData = staticData?.[StaticData.PRIVACY_POLICY];
            if (tempStaticData) {
                const payload = {
                    minValue:
                        tempStaticData?.[0] && tempStaticData?.[0]?.key ? parseInt(tempStaticData?.[0]?.key, 10) : 105,
                    maxValue:
                        tempStaticData?.[1] && tempStaticData?.[1]?.key ? parseInt(tempStaticData?.[1]?.key, 10) : 135,
                };
                dispatch(
                    updateStaticStateData({
                        key: StaticData.TEMPERATURE,
                        value: payload,
                    }),
                );
            }
            if (privacyData) {
                const emailData = privacyData?.find((item: any) => item?.key === 'email')?.value;
                const privacyPolicyLinkData = privacyData?.find((item: any) => item?.key === 'link')?.value;
                const payload = {
                    emailId: emailData,
                    privacyPolicyLink: privacyPolicyLinkData,
                };
                console.log('payload===>', payload);
                dispatch(
                    updateStaticStateData({
                        key: StaticData.PRIVACY_POLICY,
                        value: payload,
                    }),
                );
            }
        }
    };
    const handleLoginOnSuccess = async () => {
        const loginResponse = await cognitoUserPoolsTokenProvider.authTokenStore.loadTokens();

        if (loginResponse) {
            dispatch(
                setSession({
                    token: loginResponse?.idToken?.toString(),
                    payload: loginResponse?.idToken?.payload,
                }),
            );
            dispatch(updateLoginStatus(true));
            fetchData();
            navigate(navConfig.Home);
        }
    };

    return { handleLoginOnSuccess };
};
